const EnumSegment = Object.freeze({
  MAX: 50,
  MIDDLE: 25,
  MIN: 10,
});

export default EnumSegment;
